import { render, staticRenderFns } from "./SubstanceRequirementSummary.vue?vue&type=template&id=54694ec4&scoped=true&"
import script from "./SubstanceRequirementSummary.vue?vue&type=script&lang=js&"
export * from "./SubstanceRequirementSummary.vue?vue&type=script&lang=js&"
import style0 from "./SubstanceRequirementSummary.vue?vue&type=style&index=0&id=54694ec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54694ec4",
  null
  
)

export default component.exports